const getUserKeys = () => ({
  first_name: "",
  last_name: "",
  employee_id: "",
  phone: "",
  email: "",
  role: "",
  partner_id: "",
  group_id: "",
  region_id: "",
  location_id: "",
  region_ids: [], // For multi-select regions
  location_ids: [], // For multi-select locations
  cognito_username: "",
  user_level: "",
  permissions: [],
});

const requiredFields = {
  required: true,
  isValid: true,
  value: "",
  text: "",
  error: false,
  touched: false,
};

const getReqFields = () => ({
  first_name: { ...requiredFields },
  last_name: { ...requiredFields },
  phone: { ...requiredFields },
  email: { ...requiredFields },
  role: { ...requiredFields },
  // "employee_id": { required: true, isValid: true, value: '', text: '', error: false, touched: false },
  // cognito_username: {
  //   required: true,
  //   isValid: true,
  //   value: "",
  //   text: "",
  //   error: false,
  //   touched: false,
  // },
});

const getEditReqFields = () => ({
  full_name: {
    ...requiredFields,
    label: "Full Name",
  },
  employee_id: {
    ...requiredFields,
    label: "Employee ID",
    required: false,
  },
  phone: {
    ...requiredFields,
    label: "Phone",
  },
  email: {
    ...requiredFields,
    label: "Email",
  },
  role: {
    ...requiredFields,
    label: "Role",
  },
  partner_id: {
    ...requiredFields,
    label: "Partner",
  },
  group_id: {
    ...requiredFields,
    label: "Group",
  },
  region_id: {
    ...requiredFields,
    label: "Region",
  },
  region_ids: {
    ...requiredFields,
    label: "Region",
    required: false,
    value: [],
  },
  location_id: {
    ...requiredFields,
    label: "Location",
  },
  location_ids: {
    ...requiredFields,
    label: "Location",
    required: false,
    value: [],
  },
  permissions: {
    ...requiredFields,
    label: "Permissions",
    required: false,
    value: [],
  },
});

const getContactKeys = () => ({
  first_name: "",
  last_name: "",
  title: "",
  phone: "",
  contact_email: "",
  is_internal: true,
  date_of_birth: "",
  ssn_last_4: "",
  is_representative: false,
  is_ssn_provided: false,
  verification_document: {},
});

/**
 * Build permissions/levels array from user details
 * @param {Object} userDetail - User details object
 * @returns {Array} - Permissions array (called 'levels' in API but 'permissions' in payload)
 */
const buildPermissionsPayload = (userDetail) => {
  const { role, user_level, location_ids = [], region_ids = [], group_id, partner_id } = userDetail;
  
  const permissions = [];
  
  // For location and region level users with multi-select
  if (user_level === 'location' && location_ids.length > 0) {
    location_ids.forEach(level_id => {
      permissions.push({
        role,
        user_level: 'location',
        level_id,
      });
    });
  } else if (user_level === 'region' && region_ids.length > 0) {
    region_ids.forEach(level_id => {
      permissions.push({
        role,
        user_level: 'region',
        level_id,
      });
    });
  } else if (user_level === 'group' && group_id) {
    // Single group selection
    permissions.push({
      role,
      user_level: 'group',
      level_id: group_id,
    });
  } else if (user_level === 'partner' && partner_id) {
    // Partner level
    permissions.push({
      role,
      user_level: 'partner',
      level_id: partner_id,
    });
  } else if (user_level === 'subscribili') {
    permissions.push({
      role,
      user_level: 'subscribili',
      level_id: 'subscribili',
    });
  }
  return permissions;
};

/**
 * Parse permissions/levels array to user details format
 * @param {Array} levels - Levels array from API (can be called permissions or levels)
 * @returns {Object} - Parsed user level details
 */
const parsePermissionsToUserDetails = (levels = []) => {
  if (!levels || levels.length === 0) {
    return {
      role: '',
      user_level: '',
      location_ids: [],
      region_ids: [],
      location_id: '',
      region_id: '',
      group_id: '',
      partner_id: '',
    };
  }
  
  const firstLevel = levels[0];
  const { role, user_level, partner_id, group_id } = firstLevel;
  
  const result = {
    role,
    user_level,
    location_ids: [],
    region_ids: [],
    location_id: '',
    region_id: '',
    group_id: group_id || '',
    partner_id: partner_id || '',
  };
  
  // For multi-select fields, extract multiple level_ids
  if (user_level === 'location') {
    result.location_ids = levels.map(p => p.level_id);
    // Keep group_id from the first level for the form hierarchy
    result.group_id = group_id || '';
    // Support location users mapped across multiple regions
    result.region_ids = [...new Set(levels.map((p) => p.region_id).filter(Boolean))];
  } else if (user_level === 'region') {
    result.region_ids = levels.map(p => p.level_id);
    // Keep group_id from the first level for the form hierarchy
    result.group_id = group_id || '';
  } else if (user_level === 'group') {
    result.group_id = group_id || '';
  } else if (user_level === 'partner') {
    result.partner_id = partner_id || '';
  }
  
  return result;
};

const UserUtils = {
  getUserKeys,
  requiredFields,
  getReqFields,
  getEditReqFields,
  getContactKeys,
  buildPermissionsPayload,
  parsePermissionsToUserDetails,
};

export default UserUtils;
